import classNames from 'classnames';
import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';
import { ImageWrapper } from 'common/image/image-wrapper.js';
import { LinkFactoryOnClick } from 'common/link/link-on-click.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { IImageLink } from '../../utilities/image/image.js';

const ICON_EXPAND = 'expand';
const DEFAULT_RATIO = '16:9';
const SMALL_ICONS: Array<IconNameV1> = ['chevron-right'];

const ImageTileBody = ({ title, image, ratio, icon, link, action }: IImageLink) => {
  const iconName = icon || ICON_EXPAND;
  const isSmallIcon = SMALL_ICONS.includes(iconName);

  return (
    <>
      <ImageWrapper src={image} ratio={ratio || DEFAULT_RATIO} />
      {title && (
        <div className="TextWithAction">
          <p className="u-mT-0 u-mB-0 u-textBold">{title}</p>
          {(action || link) && (
            <span
              className={classNames('svg--1em TextWithAction-action', {
                'TextWithAction-action--small': isSmallIcon,
              })}
            >
              <IconV1 icon={iconName} />
            </span>
          )}
        </div>
      )}
    </>
  );
};

export const ImageTile = ({ title, image, link, action, ratio, icon }: IImageLink) => {
  const tileBodyClasses = classNames('Tile-body Tile-body--noPadding u-flex u-flexCol', {
    'Tile-body--clickable': link || action,
  });

  if (link) {
    return (
      <div className={tileBodyClasses}>
        <LinkFactoryReactRouter className="ImageTile svg-color-link--hover" href={link.url}>
          <ImageTileBody title={title} image={image} ratio={ratio} icon={icon} link={link} action={action} />
        </LinkFactoryReactRouter>
      </div>
    );
  }

  if (action) {
    return (
      <div className={tileBodyClasses}>
        <LinkFactoryOnClick className="ImageTile svg-color-link--hover" onClick={action}>
          <ImageTileBody title={title} image={image} ratio={ratio} icon={icon} link={link} action={action} />
        </LinkFactoryOnClick>
      </div>
    );
  }

  return (
    <div className={tileBodyClasses}>
      <ImageTileBody title={title} image={image} ratio={ratio} icon={icon} link={link} action={action} />
    </div>
  );
};
